import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import { FlocknoteAppState } from "Flocknote/state.js";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { SignupsAppState } from "Signups/state.js";
import { useIsSignupEditMode } from "Signups/stateHooks";

import FnrDivider from "UI/FnrDivider";
import FnrIcon from "UI/FnrIcon";
import FnrTabs from "UI/FnrTabs";
import { colors } from "UI/colors";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import AutoNavigateToLastTab from "./AutoNavigateToLastTab";
import Title from "./Title";
import useTabsConfig from "./tabsConfig";

const getIcon = (signupListTypeID) => {
  switch (signupListTypeID) {
    case 1:
      return "calendar-alt";
    case 2:
      return "ticket";
    case 4:
      return "check-square";
    case 5:
      return "tasks";
    case 7:
      return "users";
    default:
      return "check";
  }
};

export default function SignupHeader() {
  const [
    {
      currentSignupList: { ID: signupListID, title, signupListTypeID },
      user: { isAdminOfAnyGroup },
    },
  ] = useContext(SignupsAppState);
  const { isSignupEditMode: showHeaderNav } = useIsSignupEditMode();

  const [
    {
      composer: { minimized: composerMinimized },
    },
  ] = useContext(FlocknoteAppState);

  const { signupTab: currentTab } = useParams();

  useEffect(() => {
    if (currentTab) localStorage.setItem("signupsLastTab", currentTab);
  }, [currentTab]);

  const leftNavCollapsed =
    window.innerWidth < 1480 || (composerMinimized && window.innerWidth < 1140);

  const { forceToAddItem } = useNewSignupCreationFlow();

  const tabsConfig = useTabsConfig();
  return (
    <>
      <HeaderWrapper>
        <AutoNavigateToLastTab
          signupListID={signupListID}
          forceToAddItem={forceToAddItem}
          isAdminOfAnyGroup={isAdminOfAnyGroup}
        />
        <TitleRow>
          <TitleItems
            style={{
              paddingLeft: leftNavCollapsed ? 120 : 0,
            }}
          >
            {!leftNavCollapsed && (
              <FnrIcon
                far
                icon={getIcon(signupListTypeID)}
                style={{ opacity: 0.6 }}
              />
            )}
            <Title title={title} />
          </TitleItems>
        </TitleRow>
      </HeaderWrapper>
      <FnrTabs
        contentOnly={!showHeaderNav}
        clip={false}
        tabs={tabsConfig}
        activeTabKey={currentTab}
      >
        <TabsWrapper gap={4}>
          <FnrTabs.Tabs />
          <FnrDivider $color="fnGrey" />
        </TabsWrapper>
        <FnrTabs.Content />
      </FnrTabs>
    </>
  );
}

const HeaderWrapper = styled.div`
  background: ${colors.fnHeaderGray};
  width: 100%;
  flex-shrink: 0;

  @media screen and (max-width: 500px) {
    margin-top: 42px;
  }
`;

const TabsWrapper = styled(FnrVerticalGap)`
  background: ${colors.fnHeaderGray};
`;

const TitleRow = styled.div`
  padding: 20px 12px 12px 18px;
  font-size: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;

  @media screen and (max-width: 500px) {
    padding-left: 8px;
  }
`;

const TitleItems = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-right: 0.3rem;

  @media screen and (max-width: 500px) {
    padding-left: 0 !important;
  }
`;